import BusResource from "./bus.resource";

const busModule = angular
  .module("app.resources.bus", [])
  .service("Bus", BusResource);

export default busModule;



// WEBPACK FOOTER //
// ./src/resources/bus/bus.module.js